<template>
  <div class="rightaside_content" v-loading="loading">
    <h3 class="headerTitle" :class="{'waitPay': orderDetail.status===1}">{{ orderStatueMaps[orderDetail.status] }}</h3>
    <div class="headerButton">
      <span style="line-height: 28px;">订单号：<i>{{ orderDetail.orderNumber || '--' }}</i></span>
    </div>
    <div class="merchant-name">
      <div class="merchant">
        <i class="el-icon-s-shop"></i>
        <span class="name">{{orderDetail.merchantName}}</span>
      </div>
      <div class="btn-box">
        <el-button plain size="mini" @click="contactSeller">联系卖家</el-button>
        <template v-if="orderDetail.status === 1">
          <!--待支付-->
          <el-button size="mini" type="primary" @click="payOrderNow">立即支付</el-button>
          <el-button size="mini" plain @click="cancelOrder">取消订单</el-button>
        </template>
        <template v-if="orderDetail.status === 2">
          <!--待发货-->
          <el-button size="mini" type="primary" plain @click="gotoRefund(null)" v-if="orderDetail.voucherPay">申请售后</el-button>
        </template>
        <template v-if="orderDetail.status === 3">
          <!--待收货-->
          <template v-if="orderDetail.orderType === 1">
            <el-button size="mini" type="default" @click="delayConfirm(orderDetail)" v-if="orderDetail.isDelayConfirm !== 'Y'">延时收货</el-button>
            <el-button size="mini" type="primary" @click="confirmReceipt">确认收货</el-button>
          </template>
          <el-button size="mini" type="primary" @click="orderUse" v-if="orderDetail.orderType === 2 || orderDetail.orderType === 3">立即使用</el-button>
          <el-button size="mini" type="primary" plain @click="gotoRefund(null)" v-if="orderDetail.voucherPay">申请售后</el-button>
        </template>
        <template v-if="orderDetail.status === 4">
          <!--已完成-->
          <el-button size="mini" type="primary" @click="orderEvaluation" v-if="orderDetail.evaluationFlag === 'N'">订单评价</el-button>
          <el-button size="mini" type="primary" plain @click="gotoRefund(null)" v-if="orderDetail.voucherPay">申请售后</el-button>
        </template>
        <template v-if="orderDetail.status === 5">
          <!--已关闭-->
          <el-button size="mini" type="primary" plain @click="removeOrder">移除订单</el-button>
        </template>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="order_goods">
      <div class="good-item" v-for='goodsItem in orderDetail.orderCommodityList' :key="goodsItem.id">
        <el-image :src="goodsItem.specificationImg || goodsItem.commodityImage" class="good-cover">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <div class="good-info">
          <p class="good-name">{{ goodsItem.commodityName }}</p>
          <p class="good-attr">{{ goodsItem.attributes }}</p>
          <p class="good-price">￥{{ goodsItem.buyprice }} × {{ goodsItem.num || 1 }}</p>
        </div>
        <div class="good-refund">
          <template v-if="(orderDetail.status === 2 || orderDetail.status === 3 || orderDetail.status === 4) && orderDetail.voucherPay <= 0">
            <el-button size="mini" @click="gotoRefund(goodsItem)" v-if="goodsItem.afterSaleStatus === 'NONE' && orderDetail.settleStatus === 'UN_SETTLE'">申请售后</el-button>
            <el-button size="mini" @click="goRefundList(goodsItem)" v-else>查看售后</el-button>
          </template>
        </div>
      </div>
    </div>

    <!-- 等待买家付款 -->
    <el-row class="order_goods">
      <el-col :span="24" class="info_title">支付信息</el-col>
      <el-col :span="24" class="info_content">
        <p>下单时间： {{ orderDetail.createTime }}</p>
        <p v-if="orderDetail.payTime">支付时间： {{ orderDetail.payTime }}</p>
        <p v-if="orderDetail.deliveryTime">发货时间： {{ orderDetail.deliveryTime }}</p>
        <p v-if="orderDetail.latestConfirmTime">最后收货时间： {{ orderDetail.latestConfirmTime }}</p>
        <p>支付方式： {{ payWay }}</p>
      </el-col>
    </el-row>

    <template v-if="orderDetail.orderType === 1">
      <!-- 收货信息 -->
      <el-row class="order_goods">
        <el-col :span="24" class="info_title">收货信息</el-col>
        <el-col :span="24" class="info_content">
          <p>收件人： {{ orderDetail.recipient }}</p>
          <p>联系电话： {{ orderDetail.phoneNumber | phoneEncryption }}</p>
          <p>收货地址： {{ orderDetail.shipAddress }}</p>
        </el-col>
      </el-row>

      <el-row class="order_goods" v-if='orderDetail.status === 4 || orderDetail.status === 3'>
      <el-col :span="24" class="info_title">物流信息</el-col>
      <el-col :span="24" class="info_content">
        <p>物流公司： {{ orderDetail.logisticsCompanyName }}</p>
        <p>运单号码： {{ orderDetail.logisticsNumber || '等待商家发货' }}</p>
      </el-col>
      <el-col :span="24" v-if="deliver && deliver.length">
        <el-collapse v-model="activeName" accordion class="getLogistics">
          <el-collapse-item title="查看物流" name="1">
            <el-steps direction="vertical" :active="1">
              <el-step icon="el-icon-position" v-for="deliverItem in  deliver" :key="deliverItem.id"
                       :title="deliverItem.ftime" :description="deliverItem.context"></el-step>
            </el-steps>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
    </template>
    <!-- 发票信息 -->
    <el-row class="order_goods" v-if="orderDetail.bXyInvoice && orderDetail.bXyInvoice.invoiceTitle">
      <el-col :span="24" class="info_title">发票信息</el-col>
      <el-col :span="24" class="info_content">
        <p>发票类型： {{ orderDetail.bXyInvoice.type === 1 ? '电子发票' : '非电子发票' }}</p>
        <p>发票内容： {{ `发票抬头 - ${orderDetail.bXyInvoice.invoiceTitle}` }}</p>
      </el-col>
    </el-row>

    <!-- 商品总价 -->
    <div class="footer-summery">
      <div class="footer-group">
        <div class="footer-group-label">订单总价:</div>
        <div class="footer-group-val">{{ orderDetail.orderAmount | decimal }}</div>
      </div>
      <div class="footer-group">
        <div class="footer-group-label">商品总价:</div>
        <div class="footer-group-val">{{ orderDetail.goodsAmount | decimal }}</div>
      </div>
      <div class="footer-group">
        <div class="footer-group-label">商品优惠:</div>
        <div class="footer-group-val">{{ orderDetail.goodsDiscountAmount | decimal }}</div>
      </div>
      <div class="footer-group">
        <div class="footer-group-label">运费:</div>
        <div class="footer-group-val">{{ orderDetail.deliveryAmount | decimal }}</div>
      </div>
      <div class="footer-group" v-if="orderDetail.deliveryDiscountAmount">
        <div class="footer-group-label">运费优惠:</div>
        <div class="footer-group-val">{{ orderDetail.deliveryDiscountAmount | decimal }}</div>
      </div>
      <div class="footer-group" v-if="orderDetail.redPay">
        <div class="footer-group-label">红包优惠:</div>
        <div class="footer-group-val">{{ orderDetail.redPay | decimal }}</div>
      </div>
      <div class="footer-group" v-if="orderDetail.voucherPay">
        <div class="footer-group-label">代金券优惠:</div>
        <div class="footer-group-val">{{ orderDetail.voucherPay | decimal }}</div>
      </div>
      <div class="footer-group" v-if="orderDetail.discountOffer">
        <div class="footer-group-label">会员优惠:</div>
        <div class="footer-group-val">{{ orderDetail.discountOffer | decimal }}</div>
      </div>
      <div class="footer-group">
        <div class="wrapper">
          <div class="tr">
            <div class="footer-group-label">现金支付:</div>
            <div class="footer-group-val bold">{{ orderDetail.otherPay| decimal }}</div>
          </div>
          <div class="tr">
            <div class="footer-group-label">储值支付:</div>
            <div class="footer-group-val bold">{{ orderDetail.balancePay| decimal }}</div>
          </div>
        </div>
      </div>
    </div>

    <order-qrcode ref="qrcode"></order-qrcode>
  </div>
</template>
<script>
import {
  fetchOrderDetail,
  fetchOrderCancel,
  removeOrderItem,
  kuaidi100,
  fetchOrderConfirm,
  fetchDelayConfirm
} from '../../api/xunyou';
import OrderQrcode from '@/components/orderQrcode';
export default {
  name: 'myOrderDetail',
  data() {
    return {
      activeName: '1',
      loading: false,
      deliver: '',// 物流信息
      orderDetail: '',
      orderStatueMaps: {
        1: '等待买家付款',
        2: '等待卖家发货',
        3: '等待买家确认收货',
        4: '交易成功',
        5: '交易关闭',
        6: '退款待审核',
        7: '待财务审核',
        8: '等待卖家配货',
        9: '待评价',
        10: '已退单'
      },
      orderPayTypeMap: {
        'WECHAT_MP': '微信小程序',
        'WECHAT_SCAN': '微信扫码',
        'WECHAT_PUB': '微信公众号',
        'WECHAT_H5': '微信WAP',
        'WECHAT_APP': '微信APP',
        'WECHAT_WEB': '微信网页',
        'ALIPAY_SCAN': '支付宝扫码',
        'ALIPAY_H5': '支付宝WAP',
        'ALIPAY_APP': '支付宝APP',
        'ALIPAY_WEB': '支付宝网页'
      }
    }
  },
  components: {
    OrderQrcode
  },
  computed: {
    orderNumber () {
      return this.$route.query.orderNumber;
    },
    refundType () {
      return this.orderDetail.voucherPay > 0 ? 'ORDER' : 'GOOD';
    },
    payWay () {
      let txt = '在线支付';
      if (this.orderDetail.balancePay > 0) {
        txt = '混合支付';
      }
      if(this.orderDetail.payType){
        txt = txt +"-" + this.orderPayTypeMap[this.orderDetail.payType];
      }
      return txt;
    }
  },
  created() {
    this.getOrderDetail();
  },
  methods: {
    // 距离收货时间3天才允许延迟收货
    canDelay (time) {
      const diffTime = 3 * 24 * 60 * 60 * 1000;
      const confirmDate = new Date(time).getTime();
      const nowTime = new Date().getTime();
      return confirmDate - nowTime < diffTime;
    },
    // 延长收货
    delayConfirm (item) {
      this.$confirm('每笔订单只能延时收货一次！', '延时收货', {}).then(() => {
        if (this.canDelay(item.latestConfirmTime)) {
          fetchDelayConfirm({oid: item.oid})
            .then(res => {
              console.log('延时收货：', res);
              if (res.code === 0) {
                this.getList();
                this.$message.success('已延迟收货时间！');
              } else {
                this.$message.error(res.msg);
              }
            }).catch(err => {
            this.$message.error('延时收货失败，请稍后再试！');
          })
        } else {
          this.$message.error('仅距离收货时间3天内的订单允许延迟收货！');
        }
      }).catch(() => {
        console.error('取消');
      });
    },
    // 联系卖家
    contactSeller () {
      this.$tools.contactService(this.orderDetail.bxmId, 'MER');
    },
    // 立即使用
    orderUse () {
      this.$refs.qrcode.show(this.orderDetail);
    },
    goRefundList (order) {
      this.$router.push(`/refund?orderNo=${order.orderNumber}`);
    },
    // 订单详情查询
    getOrderDetail () {
      this.loading = true;
      fetchOrderDetail({ orderNumber: this.orderNumber })
        .then(res => {
          this.loading = false;
          console.log('订单详情：', res);
          if (res.code === 0) {
            this.orderDetail = res.data;
            if (this.orderDetail.logisticsNumber) {
              this.getExpressData();
            }
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
        this.loading = false;
        this.$message.error('请求失败，请稍候重试');
      });
    },
    //   物流查询
    getExpressData() {
      kuaidi100({
        tracking_num: this.orderDetail.logisticsNumber,
        logistics_id: this.orderDetail.logisticsCompany
      }).then(res => {
        console.log('物流轨迹：', res);
        this.deliver = res.data;
      })
    },

    // 前往售后
    gotoRefund (good) {
      const myRefundInfo = this.orderDetail;
      if (good) {
        myRefundInfo.orderCommodityList = [good];
      }
      sessionStorage.setItem('myRefundInfo', JSON.stringify(myRefundInfo));
      this.$router.push('/myRefund');
    },
    // 立即支付
    payOrderNow() {
      this.$store.commit('SAVE_PAY_ORDER', [this.orderDetail.orderNumber]);
      this.$router.push('/orderNow')
    },

    // 取消订单
    cancelOrder() {
      this.$confirm('确定取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        fetchOrderCancel({orderNumber: this.orderDetail.orderNumber}).then(res => {
          this.loading = false;
          if (res.code === 0) {
            this.getOrderDetail();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('查询红包失败，请稍后再试！')
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },

    // 订单评价
    orderEvaluation() {
      this.$router.push(`/orderAppraisal?orderNumber=${this.orderNumber}&bxmId=${this.orderDetail.bxmId}`);
    },
    // 移出订单
    removeOrder() {
      this.$confirm('确定移除订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        removeOrderItem({oid: this.orderDetail.oid}).then(res => {
          this.loading = false;
          if (res.code === 0) {
            this.$router.back();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('移除失败，请稍后再试！')
        });
      }).catch(() => {});
    },
    // 确认收货
    confirmReceipt() {
      this.$confirm('确定收到货物，并且货物完好？', '确认收货？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        const params = {orderNumber: this.orderDetail.orderNumber}
        this.loading = true;
        fetchOrderConfirm(params).then(res => {
          console.log('确认收货：', res);
          this.loading = false;
          if (res.code === 0) {
            this.getOrderDetail();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.loading = false;
          this.$message.error('确认收货失败，请稍后再试！');
        })
      });
    }
  }
};
</script>

<style scoped lang="less">
.headerTitle {
  font-size: 20px;
  color: #666;
  &.waitPay {
    color: var(--main-theme-color);
  }
}
.orangeColor{
  color: #ff6700;
}
.good-item{
  display:flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
  .good-cover{
    width: 70px;
    height: 70px;
    margin-right: 10px;
    border-radius: 5px;
    border:1px solid #f5f5f5;
  }
  .good-info{
    flex: 1;
  }
  .good-name{
    font-size: 14px;
    font-weight: 500;
  }
  .good-attr{
    color: var(--main-theme-color);
    font-size: 12px;
  }
  .good-price{
    margin-top: 10px;
  }
}
.footer-summery{
  padding: 5px 0;
  .footer-group{
    text-align: right;
    font-size: 14px;
    margin-bottom: 5px;
    .wrapper{
      display: inline-block;
      background-color: #ffeaea;
      padding: 5px 15px;
      border-radius: 5px;
    }
  }
  .footer-group-label{
    display: inline-block;
    padding-right: 20px;
  }
  .footer-group-val{
    display: inline-block;
    width: 100px;
    color: var(--main-theme-color);
    text-align: right;
    &:before{
      content: '￥';
      font-size: 12px;
    }
    &.bold{
      font-weight: bold;
      font-size: 18px;
    }
  }
}

.rightaside_content {
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 5px 0;
  }



  .headerButton, .merchant-name {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
  }

  .order_goods {
    border-bottom: 1px solid #DCDFE6;
    padding: 20px 0;
    box-sizing: border-box;

    .order_Info_item {
      margin-left: 10px;
    }
  }

  .info_title {
    margin: 0 0 15px;
    font-size: 16px;
    font-weight: 400;
    color: #333;
  }

  .info_content {
    color: #757575;

    p {
      margin-bottom: 4px;
    }
  }
}

// 查看物流
.getLogistics {
  border-top: 0px !important;
  border-bottom: 0px !important;

  /deep/ .el-collapse-item__header {
    border-bottom: 0px !important;
    height: auto;
    line-height: inherit;
    color: coral;
    cursor: pointer;
    display: inline-block;
    margin: 10px 0;
  }

  /deep/ .el-collapse-item__wrap {
    border-bottom: 0px !important;
  }

  /deep/ .el-step__icon {
    height: auto;
  }

  /deep/ .el-step__icon-inner[class*=el-icon]:not(.is-status) {
    font-size: 10px;
  }

  /deep/ .el-step.is-vertical .el-step__title {
    line-height: inherit;
    margin-top: 10px;
    font-weight: bold;
  }

  /deep/ .el-step.is-vertical .el-step__icon.is-icon {
    margin-top: 20px;
  }

  /deep/ .el-step__title.is-process, /deep/ .el-step__description.is-process {
    color: #C0C4CC;
  }
}
</style>







// WEBPACK FOOTER //
// src/views/myOrder/myOrderDetail.vue